import moment from "moment"

// Seems to get en-US for most English browsers regardless of user choice...
// const userLanguage = window.navigator.userLanguage || window.navigator.language
moment.locale("en-GB")
